// Centralized error handling
export const handleFirebaseError = (error) => {
  console.error('Firebase Error:', error);
  
  switch (error.code) {
    case 'auth/user-not-found':
      return 'User not found. Please check your credentials.';
    case 'auth/wrong-password':
      return 'Incorrect password. Please try again.';
    case 'auth/network-request-failed':
      return 'Network error. Please check your internet connection.';
    case 'permission-denied':
      return 'You do not have permission to perform this action.';
    case 'not-found':
      return 'The requested resource was not found.';
    case 'storage/unauthorized':
      return 'Unauthorized to access storage. Please sign in.';
    case 'storage/canceled':
      return 'Upload was canceled.';
    case 'storage/unknown':
      return 'An unknown error occurred during upload.';
    case 'auth/too-many-requests':
      return 'Too many requests. Please try again later.';
    case 'unavailable':
      return 'Service is currently unavailable. Please try again later.';
    default:
      return error.message || 'An unexpected error occurred. Please try again.';
  }
};

// Log errors for monitoring
export const logError = (error, context = {}) => {
  const errorInfo = {
    message: error.message,
    stack: error.stack,
    timestamp: new Date().toISOString(),
    context,
    userAgent: navigator.userAgent,
    url: window.location.href
  };
  
  console.error('Application Error:', errorInfo);
  
  // In production, send to error monitoring service
  if (process.env.NODE_ENV === 'production') {
    // Send to error monitoring service like Sentry
    // Sentry.captureException(error, { contexts: context });
  }
};

// Handle async errors with user feedback
export const handleAsyncError = async (asyncFunction, errorCallback = null) => {
  try {
    return await asyncFunction();
  } catch (error) {
    const userMessage = handleFirebaseError(error);
    logError(error);
    
    if (errorCallback) {
      errorCallback(userMessage);
    }
    
    throw new Error(userMessage);
  }
};

// Error boundary helper
export const createErrorBoundary = (fallbackComponent) => {
  const React = require('react');
  return class ErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = { hasError: false, error: null };
    }
    
    static getDerivedStateFromError(error) {
      return { hasError: true, error };
    }
    
    componentDidCatch(error, errorInfo) {
      logError(error, errorInfo);
    }
    
    render() {
      if (this.state.hasError) {
        return fallbackComponent || <div>Something went wrong.</div>;
      }
      
      return this.props.children;
    }
  };
};
